import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { isAnyItemFlowSubscription } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { changeSubscriptionDataCondition } from '../actions/SubscriptionsActions';
import { ISubscriptionInfo } from '../models/ISubscriptionInfo';

export const ChangeSubscriptionDataConditionEntityAction: IEntityAction<ISubscriptionInfo, {}> = {
  name: EntityActionNames.SubscriptionChangeDataSetting,
  translateName: Messages.changeSubscriptionDataCondition_action,
  isVisible: (subscriptions) => !isAnyItemFlowSubscription(subscriptions),
  isClickable: (availableActions: {}, subscriptions: ISubscriptionInfo[]) => {

    if(subscriptions.length > 1) { // We do not allow action for multiple items
      return false;
    }

    return subscriptions[0].canManageSubscription && subscriptions[0].canSpecifyDataCondition;
  },
  createReduxAction: (subscriptions: ISubscriptionInfo[]) => changeSubscriptionDataCondition(subscriptions[0])
};
